export default __webpack_public_path__ + "d9349c699660c7ee48fa1172f751da18.png";